import { useMemo } from 'react';

import {
  ReportEditorDataProvider,
  createReportEditorDataExtension,
} from '@spotify/plugin-confidence-workflows-module-report';
import { useAvailableMetrics } from '@spotify/plugin-confidence-workflows-module-stats-data';

import { useTreatmentsData } from '../hooks';
import { confidenceWorkflowsModuleAbTestPlugin } from '../plugin';

const WorkflowEditorDataProvider = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const availableMetrics = useAvailableMetrics();
  const { treatments } = useTreatmentsData();

  const value = useMemo(
    () => ({ availableMetrics, treatments }),
    [availableMetrics, treatments],
  );

  return (
    <ReportEditorDataProvider value={value}>
      {children}
    </ReportEditorDataProvider>
  );
};

export const WorkflowEditorDataExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(
    createReportEditorDataExtension({
      id: 'workflow-editor-data',
      DataProvider: WorkflowEditorDataProvider,
    }),
  );
